import './VideoPlayer.less';

export const prefix = 'bm-c-video-player';

export { default } from './VideoPlayer';
